export default "__VITE_ASSET__06bfed9f__"